import { useRef } from "react";
import { userService } from "../../_services";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

export default function EnterCodeModal(props) {
  const { t } = useTranslation();
  const formRef = useRef();
  const approveRequestSubmitHandler = (e) => {
    e.preventDefault();
    const fetch = async () => {
      let points = formRef?.current?.points?.value || 0;
      const res = await userService.approveRequestByID(
        props?.codeRes?.id,
        points
      );

      if (!res || res.length === 0) {
        toast("Invalid code");
        return;
      }
      if (res.status === "NOT_FOUND") {
        toast("Not found");
        return;
      }
      props.hideModalHandler();

      toast(
        "הלקוח: " +
        props?.codeRes?.customer?.firstName +
        " ממש:  " +
        formRef.current.points.value +
        " נקודות ",
        { autoClose: false }
      );
      formRef.current.points.value = "";

     };
    fetch();
  };

  const keyHandler = (e) => {
    if (e.code === "Enter") {
      e.preventDefault();
    }
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto" dir="rtl">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={props.hideModalHandler}></div>

      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <form
          ref={formRef}
          onSubmit={approveRequestSubmitHandler}
          className="relative w-full max-w-2xl transform overflow-hidden rounded-[2.5rem] bg-white p-8 shadow-xl transition-all"
        >
          {/* Header */}
          <div className="mb-8 text-right">
            <h2 className="text-3xl font-bold text-teal-600 relative inline-block">
              נא למלא את פרטי הבקשה ולאשר
              <span className="absolute bottom-0 right-0 w-full h-1 bg-teal-600 rounded-full transform scale-x-100"></span>
            </h2>
          </div>

          {/* Content */}
          <div className="space-y-6">
            <div className="rounded-xl bg-gray-50 p-6">
              <div className="mb-6 border-b border-gray-200 pb-4">
                <h3 className="text-2xl	 font-bold text-gray-800 relative inline-block">
                  נתוני הבקשה
                  <span className="absolute bottom-0 right-0 w-full h-0.5 bg-gray-800 transform scale-x-0 transition-transform duration-300 group-hover:scale-x-100"></span>
                </h3>
              </div>

              <div className="space-y-4 text-right">
                <div className="flex items-center gap-2">
                  <span className="font-medium text-gray-800 text-lg">{t('customerName')}</span>
                  <span className="text-gray-600 text-lg">{props?.codeRes?.customer?.firstName}</span>
                </div>

                <div className="flex items-center gap-2">
                  <span className="font-medium text-gray-800 text-lg">{t('requestType')}</span>
                  <span className="text-gray-600 text-lg">{props?.codeRes?.type}</span>
                </div>

                <div className="flex items-center gap-2">
                  <span className="font-medium text-gray-800 text-lg">{t('offerDescription')}</span>
                  <span className="text-gray-600 text-lg">{props?.codeRes?.offerDescription}</span>
                </div>

                {props?.codeRes?.offerType !== "free" && (
                  <>
                    <div className="flex items-center gap-2">
                      <span className="font-medium text-gray-800 text-lg">{t('pointsLeft')}</span>
                      <span className="text-gray-600 text-lg">{props?.codeRes?.pointsStatus}</span>
                    </div>

                    <div className="flex items-center gap-2">
                      <span className="font-medium text-gray-800 text-lg">{t('amountPointsToPunch')}</span>
                      <input
                        onKeyDown={keyHandler}
                        className="h-10 w-32 rounded-lg border border-gray-300 px-4 text-center focus:border-teal-500 focus:outline-none focus:ring-2 focus:ring-teal-500/20"
                        required
                        type="number"
                        name="points"
                        defaultValue="1"
                        min="1"
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="mt-8 flex gap-4 flex-row-reverse">
            <button
              type="button"
              onClick={props.hideModalHandler}
              className="flex-1 rounded-full border border-gray-300 bg-white px-6 py-3 text-gray-700 transition-colors hover:bg-gray-50"
            >
              לבטל
            </button>
            <button
              type="submit"
              className="flex-1 rounded-full bg-teal-500 px-6 py-3 text-white transition-colors hover:bg-teal-600"
            >
              לאישור
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
